import { useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import Accordeon from '../CustomElements/Accordeon';
import Selector from '../CustomElements/Selector';
// Кастомные хуки
import useOptionsLoader from '../../customHook/useOptionsLoader';
import ResetFiltersButton from '../CustomElements/ResetFiltersButton';
// Утилиты
import { handleUniversalChange } from '../../utils/formUtils';
// Действия Redux
import {
  initDepartmentOptionsFromServer,
  initOptionsDirectoratesFromServer,
  initOptionsSectionFromServer,
} from '../../redux/actions/options.action';

// Компонент для фильтрации инфокарт

export default function FilterForInfocards({ formData, setFormData, showBtnReset, resetFilters, t }) {
  // получаем опции из стора
  const optionsForSelect = useSelector((s) => s.options);

  //опции для селекта версий
  const versionOptions = [
    { value: 'all', label: t?.versionAll || 'Все' },
    { value: 'diff', label: t?.versionDiff || 'Различные' },
    { value: 'same', label: t?.versionSame || 'Совпадающие' },
  ];

  const modeOptions = [
    { value: 'true', label: t?.accessTrue || 'Не доступен' },
    { value: 'false', label: t?.accessFalse || 'Доступен' },
  ];

  //хук для запроса опций для дирекций и контроля селекта
  const messageForSelectDirectorates = t?.selectRoad || 'Выберите дорогу';
  const directoratesControl = useOptionsLoader(
    formData,
    setFormData,
    ['directorate', 'department', 'station'],
    'road',
    initOptionsDirectoratesFromServer,
    messageForSelectDirectorates
  );

  //хук для запроса опций для подразделений и контроля селекта
  const messageForSelectDepartments = t?.selectDirectorate || 'Выберите дирекцию';
  const departmentsControl = useOptionsLoader(
    formData,
    setFormData,
    ['department'],
    'directorate',
    initDepartmentOptionsFromServer,
    messageForSelectDepartments
  );

  //хук для запроса опций для станций и контроля селекта
  const messageForSelectStation = t?.selectRoad || 'Выберите дорогу';
  const stationControl = useOptionsLoader(
    formData,
    setFormData,
    ['station'],
    'road',
    initOptionsSectionFromServer,
    messageForSelectStation
  );

  return (
    <Accordeon header={t?.infocards || "ИНФОКАРТЫ"} hideAbove={1650} qParamName="infocards_acc">
      <ResetFiltersButton showBtnReset={showBtnReset} onReset={resetFilters} />

      <form className="accordeon__form" autoComplete="off">
        <div className="accordeon__select-container">
          <Selector
            options={optionsForSelect.roads}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'road', selectedOption, 'select');
            }}
            isMulti={false}
            label={t?.road || 'Дорога'}
            placeholder={t?.selectRoad || 'Выберите дорогу'}
            value={formData.road ? optionsForSelect?.roads?.find((option) => option.value === formData.road) : null}
            name="road"
          />
          <Selector
            options={optionsForSelect?.directorates}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'directorate', selectedOption, 'select');
            }}
            label={t?.directorate || 'Дирекция'}
            placeholder={t?.selectDirectorate || 'Выберите дирекцию'}
            value={
              formData.directorate
                ? optionsForSelect?.directorates?.find((option) => option.value === formData.directorate)
                : null
            }
            isMulti={false}
            name="directorate"
            isDisabled={directoratesControl?.isSelectorDisabled}
            message={directoratesControl?.message}
            customClick={directoratesControl?.onSelectorChange}
          />
          <Selector
            options={optionsForSelect.departments}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'department', selectedOption, 'select');
            }}
            placeholder={t?.selectDepartment || 'Выберите № подразделения'}
            isMulti={false}
            label={t?.department || 'Подразделение'}
            value={
              formData.department
                ? optionsForSelect?.departments?.find((option) => option.value === formData.department)
                : null
            }
            name="department"
            isDisabled={departmentsControl?.isSelectorDisabled}
            message={departmentsControl?.message}
            customClick={departmentsControl?.onSelectorChange}
          />
          <Selector
            options={optionsForSelect?.stations}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'station', selectedOption, 'select');
            }}
            value={
              formData.station ? optionsForSelect.stations?.find((option) => option.value === formData.station) : null
            }
            isMulti={false}
            placeholder={t?.stationPlaceholder || 'Выберите станцию/перегон'}
            name="station"
            label={(t?.stationLabel || 'Станция/перегон').replace(/\s*\*$/, '')}
            isDisabled={stationControl?.isSelectorDisabled}
            message={stationControl?.message}
            customClick={stationControl?.onSelectorChange}
          />

          <Selector
            options={versionOptions}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'version', selectedOption, 'select');
            }}
            value={formData.version ? versionOptions?.find((option) => option.value === formData.version) : null}
            isMulti={false}
            name="version"
            label={t?.versionLabel || 'Версия САДР/КИТ'}
            placeholder={t?.versionPlaceholder || 'Выберите версию'}
          />
          <Selector
            options={modeOptions}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'isDisabled', selectedOption, 'select');
            }}
            value={versionOptions?.find((option) => option.value === formData.isDisabled)}
            isMulti={false}
            name="isDisabled"
            label={t?.accessLabel || 'Доступ'}
            placeholder={t?.accessPlaceholder || 'Выберите режим'}
          />
        </div>
      </form>
    </Accordeon>
  );
}
